<template>
  <i class="fa fa-fw fa-mobile"></i>
</template>

<script>
export default {
  name: 'Cellfind',
};
</script>
<style scoped>
.fa-mobile {
  color: #2993cf;
}
</style>



// WEBPACK FOOTER //
// CellfindIcon.vue?6d5962fa